import React from 'react';
import FilterButton from 'components/ui/filter_button';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterRow from 'components/search_page/filter_row';
import Button from 'shared/button';
import PropTypes from 'prop-types';
import FilterNumberPair from '../search_sidebar/filter_number_pair';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@fortawesome/pro-solid-svg-icons';

export default function FiltersLimitedToOneRow(props) {
  const {
    behaviorToggle,
    filterMapping,
    handleSearchChange,
    searchPlaceholder,
    searchText,
    showAllFiltersButton,
    toggleAllFiltersModal
  } = props;

  const validFilterMappingNames = Object.keys(filterMapping).filter((name) => {
    const { filterKey, handleChange } = filterMapping[name];
    const filter = props[filterKey];
    return filter && handleChange;
  });

  function renderFilter(name) {
    const type = filterMapping[name].type;
    if (type === 'range') {
      return renderRangeFilter(name);
    } else if (type === 'select') {
      return renderSelectOneFilter(name);
    } else {
      return renderCheckboxGroupFilter(name);
    }
  }

  function renderRangeFilter(name) {
    const { filterKey, label, handleChange } = filterMapping[name];
    const filter = props[filterKey];
    const filtersApplied = filter.min !== '' || filter.max !== '';

    const isLeaseRateFilter = name === 'leaseRate' || label.includes('Lease Rate');

    return (
      <FilterButton
        className={isLeaseRateFilter ? 'lease-rate-filter' : ''}
        filtersApplied={filtersApplied}
        label={label}
        name={name}
      >
        <FilterNumberPair
          filter={filter}
          maxPlaceholder="Max"
          name={`${name}InputGroup`}
          valueKeys={['min', 'max']}
          onChange={handleChange}
        />
      </FilterButton>
    );
  }

  function renderSelectOneFilter(name) {
    const { filterKey, handleChange, options } = filterMapping[name];
    const filter = props[filterKey];
    if (!filter || !handleChange || !options || options.length === 0) return null;

    return (
      <div
        className={
          'filter-button d-flex align-items-center justify-content-between has-filters'
        }
      >
        <FilterSelect
          options={options}
          onChange={handleChange}
        />
      </div>
    );
  }

  function renderCheckboxGroupFilter(name) {
    const { filterKey, label, handleChange, maxNumberOfOptions, options } = filterMapping[name];
    const filter = props[filterKey];
    if (!filter || !handleChange || !options || options.length === 0) return null;

    return (
      <FilterButton
        filtersApplied={filter.length > 0}
        label={label}
        name={name}
        popoverBodyClassName="overflow-y-auto"
      >
        <FilterCheckboxGroup
          behaviorToggle={name === behaviorToggle?.optionToToggle ? behaviorToggle : null}
          maxNumberOfOptions={maxNumberOfOptions}
          name={`${name}InputGroup`}
          options={options}
          selected={filter}
          onChange={handleChange}
        />
      </FilterButton>
    );
  }

  const placeholder = searchPlaceholder || 'Search by name';
  return (
    <div className="filter-row-container">
      <FilterRow
        renderContainerAsDiv={false}
        searchPlaceholder={placeholder}
        searchText={searchText}
        onSearchChange={handleSearchChange}
      >
        {(validFilterMappingNames).map(validFilterMappingName => (
          <React.Fragment key={validFilterMappingName}>
            {renderFilter(validFilterMappingName)}
          </React.Fragment>
        ))}
        { showAllFiltersButton &&
          <Button.Primary name="allFilters" outlined onClick={toggleAllFiltersModal}>
            <FontAwesomeIcon icon={faSliders}/>
            All Filters
          </Button.Primary>
        }
      </FilterRow>
    </div>
  );
}

FiltersLimitedToOneRow.propTypes = {
  behaviorToggle: PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    optionToToggle: PropTypes.string
  }),
  filterMapping: PropTypes.object.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  searchPlaceholder: PropTypes.string,
  searchText: PropTypes.string.isRequired,
  showAllFiltersButton: PropTypes.bool,
  toggleAllFiltersModal: PropTypes.func.isRequired
};
